import { render, staticRenderFns } from "./CreateArmada.vue?vue&type=template&id=12308162&scoped=true&"
import script from "./CreateArmada.vue?vue&type=script&lang=js&"
export * from "./CreateArmada.vue?vue&type=script&lang=js&"
import style0 from "./CreateArmada.vue?vue&type=style&index=0&id=12308162&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12308162",
  null
  
)

export default component.exports